
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/locale/novaskin",
      function () {
        return require("private-next-pages/locale/novaskin.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/locale/novaskin"])
      });
    }
  